import { Link, useLocation } from 'react-router-dom';
import { isArPath } from '../i18nRoutes';

const MONTHS_AR = { 'October 2026': 'أكتوبر 2026', 'July 2026': 'يوليو 2026', 'June 2026': 'يونيو 2026', 'May 2026': 'مايو 2026', 'April 2026': 'أبريل 2026', 'September 2025': 'سبتمبر 2025', 'August 2025': 'أغسطس 2025' };
const dateAr = (isAr, d) => (isAr && MONTHS_AR[d]) || d;
import '../pages/AuthorProfile.css';

const AKIN_PHOTO = '/images/akin-guzel-portrait.webp';

/**
 * Person Schema for Akın Güzel — add to @graph arrays on content pages
 */
export const akinPersonSchema = {
  "@type": "Person",
  "@id": "https://viaturkey.net/about/akin-guzel/#person",
  "name": "Akın Güzel",
  "alternateName": "Akin Guzel",
  "givenName": "Akın",
  "familyName": "Güzel",
  "jobTitle": "Licensed Tour Guide & Travel Consultant",
  "worksFor": {
    "@type": "TravelAgency",
    "@id": "https://viaturkey.net/#travel-agency",
    "name": "Viaturkey Investments & Tourism Co.",
    "url": "https://viaturkey.net"
  },
  "alumniOf": {
    "@type": "CollegeOrUniversity",
    "name": "Erciyes University",
    "department": "Faculty of Tourism — Tour Guiding Department"
  },
  "hasCredential": [
    {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "license",
      "name": "Professional Tour Guide License (Kokart)",
      "recognizedBy": {
        "@type": "GovernmentOrganization",
        "name": "Republic of Turkey, Ministry of Culture and Tourism"
      }
    },
    {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "degree",
      "name": "Bachelor of Arts in Tourism — Tour Guiding"
    }
  ],
  "knowsLanguage": ["Turkish", "English", "Russian", "Arabic"],
  "knowsAbout": [
    "Turkish Citizenship by Investment",
    "Istanbul Private Tours",
    "Real Estate Consulting Turkey",
    "Turkish Residence Permits",
    "Travel Itinerary Planning"
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "TR",
    "addressLocality": "Istanbul"
  },
  "sameAs": [
    "https://www.instagram.com/via_turkey",
    "https://www.youtube.com/@akinguzel1490",
    "https://www.tiktok.com/@akingzel",
    "https://x.com/akngzl3",
    "https://www.tripadvisor.com/Attraction_Review-g293974-d25289505-Reviews-or10-Viaturkey_Tours-Istanbul.html"
  ],
  "url": "https://viaturkey.net/about/akin-guzel"
};

/**
 * Author reference for article schemas
 */
export const authorRef = {
  "@type": "Person",
  "name": "Akın Güzel",
  "url": "https://viaturkey.net/about/akin-guzel"
};

/**
 * Top byline — placed after H1 on content pages
 */
export function AuthorByline({ publishDate, updateDate }) {
  const isAr = isArPath(useLocation().pathname);
  return (
    <div className="author-byline" data-testid="author-byline">
      <img src={AKIN_PHOTO} alt={isAr ? 'أكين غوزيل' : 'Akın Güzel'} className="author-byline-photo" loading="lazy" />
      <span>
        {!isAr && 'By '}<Link to="/about/akin-guzel">{isAr ? 'أكين غوزيل' : 'Akın Güzel'}</Link>
        <span className="author-byline-sep"> | </span>
        {isAr ? 'مرشد سياحي مرخّص ومستشار سفر' : 'Licensed Tour Guide & Travel Consultant'}
        {publishDate && (<><span className="author-byline-sep"> | </span>{isAr ? 'نُشر' : 'Published'} {dateAr(isAr, publishDate)}</>)}
        {updateDate && (<><span className="author-byline-sep"> | </span>{isAr ? 'آخر تحديث' : 'Updated'} {dateAr(isAr, updateDate)}</>)}
      </span>
    </div>
  );
}

/**
 * Bottom author card — placed near the end of content pages
 */
export function AuthorBottomCard() {
  const isAr = isArPath(useLocation().pathname);
  return (
    <div className="author-bottom-card" data-testid="author-bottom-card">
      <img src={AKIN_PHOTO} alt={isAr ? 'أكين غوزيل' : 'Akın Güzel'} className="author-bottom-card-photo" loading="lazy" />
      <div className="author-bottom-card-info">
        <h4>{isAr ? 'أكين غوزيل' : 'Akın Güzel'}</h4>
        <p className="author-bottom-title">{isAr ? 'مؤسس فياتركي · مرشد سياحي مرخّص' : 'Founder of Viaturkey · Licensed Tour Guide'}</p>
        <p className="author-bottom-tagline">{isAr ? '17 عاماً من الخبرة · أكثر من 1000 عميل دولي' : '17 years of experience · 1,000+ international clients served'}</p>
        <Link to="/about/akin-guzel" className="author-bottom-bio-link">{isAr ? 'اقرأ السيرة كاملة ←' : 'Read full bio →'}</Link>
        <div className="author-bottom-card-socials">
          <a href="https://www.instagram.com/via_turkey" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
          <a href="https://www.youtube.com/@akinguzel1490" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
          <a href="https://www.tiktok.com/@akingzel" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><i className="fab fa-tiktok"></i></a>
        </div>
      </div>
    </div>
  );
}
